import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";

/**
 * Opens the language dropdown. Kept separate from the data-fetch action
 * (GetPreferredLanguagesAction) so the preferred-languages list can be
 * pre-fetched at app startup without forcing the menu open.
 */
class OpenLanguageDropdownAction extends BaseAction<void, void> {
    override async run(): Promise<void> {
        try {
            updateRecoilState("languageDropdownOpenAtom", true);
        } catch (error: any) {
            console.error("Error opening language dropdown:", error);
        }
    }
}

export const openLanguageDropdownAction = new OpenLanguageDropdownAction();
